import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { modalController } from '@ionic/core';
import { dismiss } from '@ionic/core/dist/types/utils/overlays';

@Component({
  selector: 'app-popup-card',
  templateUrl: './popup-card.component.html',
  styleUrls: ['./popup-card.component.scss'],
  standalone: false // same as ConfirmEmailComponent
})
export class PopupCardComponent {
  @Input() illustration: string;
  @Input() message: string = '';
  @Input() primaryLabel: string = 'YES';
  @Input() secondaryLabel: string = 'NO';
  @Input() title: string = 'Are you sure?';

  @Output() close = new EventEmitter<void>();
  @Output() primaryAction = new EventEmitter<void>();
  @Output() secondaryAction = new EventEmitter<void>();

  private modalController = inject(ModalController);

  closePopup() {
    this.close.emit();
    this.modalController.dismiss();
  }

  onPrimary() {
    modalController.dismiss({ success: true });
    this.primaryAction.emit();
    this.closePopup();
  }

  onSecondary() {
    modalController.dismiss({ success: false });
    this.secondaryAction.emit();
    this.closePopup();
  }

  private handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Escape' || event.key === 'Esc') {
      this.closePopup();
    }
  };

  ngOnInit(): void {
    window.addEventListener('keydown', this.handleKeyDown);
  }

  ngOnDestroy(): void {
    window.removeEventListener('keydown', this.handleKeyDown);
  }
}
